const messages = {
    'stations': {
        ru: 'Станции',
        en: 'Stations',
    },
    'menu': {
        ru: 'Меню',
        en: 'Menu',
    },
    'news': {
        ru: 'Новости',
        en: 'News',
    },
    'contacts': {
        ru: 'Контакты',
        en: 'Contact',
    },
    // 'as_list': {
    //     ru: 'списком',
    //     en: 'as list',
    // },
    'gastronomic_center': {
        ru: 'Гастрономический центр',
        en: 'Gastronomic Center'
    },
    'main_page_description': {
        ru: 'Современный фуд-маркет, где на 8 гурмэ-островах готовят блюда по переосмысленным рецептам кухни российских регионов',
        en: 'A modern food market, where 8 gourmet islands cook dishes based on the recipe of the cuisine of Russian regions'
    },
    'main_title': {
        ru: 'Гастрономический Центр Зарядье',
        en: 'Gastronomic Center Zaryadye'
    },
    'more': {
        ru: 'Подробнее',
        en: 'See more'
    },
    'title': {
        ru: 'Зарядье',
        en: 'Zaryadye'
    },
    'scroll': {
        ru: 'Скрольте вниз',
        en: 'Scroll down'
    },
    'food_menu': {
        ru: 'Меню',
        en: 'Food menu'
    },
    'drinks': {
        ru: 'Напитки',
        en: 'Drinks'
    },
    'concept': {
        ru: 'Концепция',
        en: 'Concept'
    },
    'next_station': {
        ru: 'Следующая станция',
        en: 'Next station'
    },
    'moscow': {
        ru: 'Москва',
        en: 'Moscow'
    },
    'rus': {
        ru: 'Россия',
        en: 'Russia'
    },
    'address_street': {
        ru: 'ул. Варварка, влад. 6',
        en: '6 Varvarka street'
    },
    'view_map': {
        ru: 'Посмотреть на карте',
        en: 'View on map'
    },
    'not_found': {
        ru: 'Страница не найдена',
        en: 'Page Not Found'
    },
    'not_found_desc': {
        ru: 'К сожалению, страница, которую вы пытались просмотреть, не существует.',
        en: 'Sorry, the page you were trying to view does not exist.'
    },
    'find_us': {
        ru: 'Найти нас',
        en: 'Find us'
    },
    'phone': {
        ru: 'Номер телефона',
        en: 'Phone number'
    },
    'work_time': {
        ru: 'Время работы',
        en: 'Open hours'
    },
    'daily': {
        ru: 'Ежедневно',
        en: 'Daily'
    },
    'from': {
        ru: 'с',
        en: 'from'
    },
    'to': {
        ru: 'до',
        en: 'to'
    },
    'news_events': {
        ru: 'Наши события',
        en: 'Our events'
    },
    'news_stocks': {
        ru: 'Наши акции',
        en: 'Our stocks'
    },
    'news_title': {
        ru: 'Наши новости, акции,<br/>события',
        en: 'Our news, stocks,<br/>events'
    },
    'park': {
        ru: 'О парке',
        en: 'Park'
    },
    'discover_more': {
        ru: 'Узнайте Больше',
        en: 'Discover More'
    },
    'about_park': {
        ru: 'Рядом с Кремлем и Красной площадью расположился парк и культурный центр с научными лабораториями, выставочными пространствами, медиакомплексом и даже подземной оранжереей. Прибавьте к этому ландшафтные зоны, памятники архитектуры и любимые смотровые площадки под открытым небом — это и есть «Зарядье».',
        en: 'There is a new park and cultural centre near the Kremlin and Red Square. The park features an interactive archaeology museum, a floral greenhouse, installations from leading cultural institutions, and a large open-air amphitheatre'
    },
    'all': {
        ru: 'Все',
        en: 'All'
    },
    'events': {
        ru: 'События',
        en: 'Events'
    },
    'promotions': {
        ru: 'Акции',
        en: 'Promotions'
    },
    'read_also': {
        ru: 'Читайте также',
        en: 'Read also'
    },
    'media_center': {
        ru: 'Медиацентр',
        en: 'Media Center'
    },
    'media_center_desc': {
        ru: 'Первый павильон на пути от Красной площади. Здесь расположены медиакомплекс «Полет» и Медиахолл 360, Информационная стойка Медиацентра, Выставочный зал и магазин сувениров. Администраторы на русском и английском языке расскажут о мероприятиях «Зарядья», продадут билеты, помогут составить маршруты для прогулок по парку или центру города, подобрать гида, заказать экскурсию на туристическом автобусе или теплоходе и даже спланировать путешествие по России.',
        en: 'Media Center is the first pavilion in the park on the way from Red Square and is the most crowded space of Zaryadye. Here you will find a tourist information center, two modern media complexes - Soaring and Time Machine, an exhibition hall, a souvenir shop and a cafe. In front of the entrance to the Media Center, as well as inside the pavilions, there are information stands "Moscow Now" - interactive terminals with a billboard of cultural events of Zaryadye and information about all the sights in the park. On the lower ground of the pavilion a multifunctional exhibition space for temporary expositions is located.'
    },
    'florarium': {
        ru: 'Флорариум',
        en: 'Florarium'
    },
    'florarium_desc': {
        ru: 'Оранжерейный комплекс парка&nbsp;&mdash; Флорариум&nbsp;&mdash; это особый &laquo;космический&raquo; мир. Необычная форма в&nbsp;виде воронки, расположенные по&nbsp;спирали растения, повсюду железные трубки и&nbsp;много яркого света.',
        en: 'Artificial climate in a greenhouse with a glass roof allows maintaining the temperature and humidity regime necessary for heat-loving plants.'
    },
    'nature_center': {
        ru: 'Заповедное посольство',
        en: 'Nature Center'
    },
    'nature_center_desc': {
        ru: 'Научно-познавательный центр для проведения лабораторных экспериментов, конференций, мастер-классов, лекций и семинаров. Здесь изучают генетику, биотехнологию, микробиологию, географию и экологию. Просветительские программы рассчитаны на детей и взрослых. Здесь же находится Флорариум – многоярусная оранжерея c растениями из разных природных зон России.',
        en: 'Scientific-educational center for conducting laboratory experiments, conferences, lectures and seminars on genetics, biotechnology, microbiology, geography, and ecology. Educational programs, quests and master classes of the Nature Center are designed for children of different ages, students and adults. In this pavilion, there is also a Florarium - a multi-staged greenhouse with an artificial climate for the cultivation of tropical plants with the help of an aeroponic system - growing plants in aerial environment without using soil.'
    },
    'ice_cave': {
        ru: 'Ледяная пещера',
        en: 'Ice Cave'
    },
    'ice_cave_desc': {
        ru: 'Пространственная арт-инсталляция художника Александра Пономарева и архитектора Алексея Козыря. Это возможность совершить путешествие в мир снега и льда и ощутить силу и величие природы Севера.',
        en: 'The Ice Cave is a spatial art installation by artist Aleksandr Ponomarev and architect Aleksey Kozyr.'
    },
    'dome': {
        ru: 'Купол',
        en: 'Dome'
    },
    'dome_desc': {
        ru: 'Центральный зал павильона представляет собой купольное пространство, покрытое орнаментом из QR-кодов. Перейдя по ним, гости смогут узнать подробнее о том, что происходит сейчас в «Зарядье» и в городе.',
        en: 'The central hall of the pavilion is a dome space covered with ornamentation made up from QR-codes.'
    },
    'underground_museum': {
        ru: 'Подземный музей',
        en: 'Underground Museum'
    },
    'underground_museum_desc': {
        ru: 'Когда-то на&nbsp;месте музея находилась самая первая улица Москвы&nbsp;&mdash; Великая. Теперь в&nbsp;подземном пространстве, примыкающем к&nbsp;Москворецкой набережной, создан современный интерактивный археологический музей.',
        en: 'Once on the site of the museum, was the very first street in Moscow – the Main street (Velikaya). Now in the underground space adjacent to the Moskvoretskaya embankment, a modern interactive archaeological museum has been created.'
    },
    'media': {
        ru: 'СМИ о нас',
        en: 'Media'
    },
    'media_title': {
        ru: 'СМИ о нас',
        en: 'Media'
    },
};

export default messages;



// WEBPACK FOOTER //
// ./src/js/messages.js